import React, { ReactElement } from 'react';
import PropTypes from 'prop-types';

import ProjectFilterMultiSelect from './ProjectFilterMultiSelect';
import './ProjectFilter.scss';
import { buyOptionsMap, projectStatusMap } from '../Portfolio/Data';
import { bezirke } from '../Layout/Footer/BezirkFilter';
import history from '../../history';
import '../home/home.scss';

const filterMap = {
  zip: 'filteredZips',
  metro: 'filteredSubways',
  kaufen_mieten: 'filteredBuyOptions',
  planung_bau: 'filteredProjectStatus',
};

const zipOptions = bezirke.map((bezirk) => ({
  name: bezirk.name,
  code: bezirk.number.toString(),
}));

const subwayOptions = [
  { name: 'U1', code: 'U1' },
  { name: 'U2', code: 'U2' },
  { name: 'U3', code: 'U3' },
  { name: 'U4', code: 'U4' },
  { name: 'U6', code: 'U6' },
];

const buyOptions = [
  { name: buyOptionsMap.buy, code: 'buy' },
  { name: buyOptionsMap.rent, code: 'rent' },
];

const projectStatusOptions = [
  { name: projectStatusMap.done, code: 'done' },
  { name: projectStatusMap.building, code: 'building' },
  { name: projectStatusMap.planing, code: 'planing' },
];

// TODO: type definition
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getFilterFromSearch = (query: URLSearchParams): any => {
  const queries = Object.fromEntries(query.entries());
  const newFilters = {};
  Object.keys(queries).forEach((queryKey) => {
    let filterValues = [];
    const values = queries[queryKey].split(',');

    let options = [];
    if (queryKey === 'zip') {
      options = zipOptions;
    } else if (queryKey === 'metro') {
      options = subwayOptions;
    } else if (queryKey === 'kaufen_mieten') {
      options = buyOptions;
    } else if (queryKey === 'planung_bau') {
      options = projectStatusOptions;
    }
    filterValues = values.map((value) =>
      options.find((option) => option.code === value)
    );

    newFilters[filterMap[queryKey]] = filterValues;
  });
  return newFilters;
};

interface ProjectFilterProps {
  query: URLSearchParams;
}

export default function ProjectFiler(props: ProjectFilterProps): ReactElement {
  const { query } = props;
  const filters = getFilterFromSearch(query);

  const {
    filteredZips,
    filteredSubways,
    filteredBuyOptions,
    filteredProjectStatus,
  } = filters;

  const updateSearchQuery = (val, name) => {
    if (val.length === 0) {
      query.delete(name);
    } else {
      query.set(name, val.map((v) => v.code).join(','));
    }
    history.push({
      pathname: `/`,
      search: `?${query.toString()}`,
    });
  };

  const handleChangeZip = (val) => {
    updateSearchQuery(val, 'zip');
  };

  const handleChangeSubways = (val) => {
    updateSearchQuery(val, 'metro');
  };

  const handleChangeBuyOptions = (val) => {
    updateSearchQuery(val, 'kaufen_mieten');
  };

  const handleChangeProjectStatuses = (val) => {
    updateSearchQuery(val, 'planung_bau');
  };
  return (
    <div>
      <div className="p-grid projectFilterContainer mainContent">
        <ProjectFilterMultiSelect
          value={filteredZips}
          options={zipOptions}
          onChange={handleChangeZip}
          placeholder="Alle Bezirke"
        />

        <ProjectFilterMultiSelect
          value={filteredSubways}
          options={subwayOptions}
          onChange={handleChangeSubways}
          placeholder="U-Bahn"
        />

        <ProjectFilterMultiSelect
          value={filteredBuyOptions}
          options={buyOptions}
          onChange={handleChangeBuyOptions}
          placeholder="Mieten &amp; Kaufen"
        />

        <ProjectFilterMultiSelect
          value={filteredProjectStatus}
          options={projectStatusOptions}
          onChange={handleChangeProjectStatuses}
          placeholder="Planung &amp; Bau"
        />
      </div>
    </div>
  );
}

ProjectFiler.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  query: PropTypes.object.isRequired,
};
